import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons'
import { Button, DropdownButton } from '@seiue/ui'

import {
  BlockStateEnum,
  blockTypeToLabel,
  HeaderTypes,
} from 'packages/feature-utils/test-paper'
import { BlockTypeEnum } from 'packages/sdks-next/growp'

import { BlockFooter } from '../../BlockFooter'
import { FooterComponent } from '../../BlockWrapper/types'

/**
 * Header 选中态下的 Footer
 *
 * @param {FooterComponent} param0 - 参数对象
 * @returns Header 选中态下的 Footer
 */
export const HeaderSelectedFooter: FooterComponent = ({
  onDelete,
  onChangeState,
  blockData,
  onChangeBlockData,
  key,
  canEdit,
}) => {
  return (
    <BlockFooter
      key={key}
      left={
        canEdit ? (
          <DropdownButton
            label={blockTypeToLabel.get(blockData.type)}
            labelButtonProps={{
              type: 'text',
              size: 'xs',
            }}
            showSelected
            selectedKeys={[blockTypeToLabel.get(blockData.type)]}
            trigger="click"
            items={HeaderTypes.map((titleType: BlockTypeEnum) => ({
              label: blockTypeToLabel.get(titleType),
              callback: () => {
                onChangeBlockData(
                  {
                    type: titleType,
                  },
                  {
                    immediateUpdate: true,
                  }
                )

                onChangeState(BlockStateEnum.Display)
              },
            }))}
          />
        ) : (
          <div>{blockTypeToLabel.get(blockData.type)}</div>
        )
      }
      right={
        <Button
          icon={faTrashAlt}
          size="xs"
          type="text"
          onClick={() => onDelete()}
        >
          {'删除'}
        </Button>
      }
    />
  )
}
